export const config = {
    API_URL: process.env.API_URL || "https://api.diadibi.net/",
    OPENAI_MODEL: process.env.OPENAI_MODEL ||"gpt-4o",
    API_BASE_URL: process.env.API_BASE_URL || "https://api.diadibi.net/",
}

